








import {
  AvailablePaidMembershipPlanInGroup
} from '@/models/api/paid-member-price/member-plan/group/available-paid-membership-plan-group'
import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

@Component
export default class ChangeSucceed extends Vue {
  @Prop({ required: true })
  readonly before: AvailablePaidMembershipPlanInGroup

  @Prop({ required: true })
  readonly after: AvailablePaidMembershipPlanInGroup
}
